module.exports = __webpack_public_path__ + "img/lite-room.e0e9ea2d.jpg";